export function getDefaultInternetAmenityPlan(providers) {
  const plans = providers.map((provider) => provider.plans).flat();

  const plansWithInternetAmenityPlanId = plans
    .filter((plan) => plan.internetAmenityPlanId)
    .map((plan) => plan.id);

  return plansWithInternetAmenityPlanId;
}
